import { render, staticRenderFns } from "./qProductPopup.vue?vue&type=template&id=69984cbf&scoped=true&"
import script from "./qProductPopup.vue?vue&type=script&lang=ts&"
export * from "./qProductPopup.vue?vue&type=script&lang=ts&"
import style0 from "./qProductPopup.vue?vue&type=style&index=0&id=69984cbf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69984cbf",
  null
  
)

export default component.exports